import gql from "graphql-tag";

export const GET_PRE_ORDER_TRIP_WITH_ORDERS = gql`
query getTripWithOrders($id: uuid){
    VehicleTrip(where: {id: {_eq: $id}}){
        id
        tripId
        statusId
        organizationId        
        Order{id OrderItems{id quantity productId unitId Product{id displayName price bunchPrice noOfPieceInBox retailer weight colorCode packageType image bunchKg} }}                    
    }
}`

export const GET_ORGANIZATION_STOCK_FOR_TRIP = gql`
query getOrgStock($id: uuid!, $productIds: [uuid!]){
    OrganizationStock(where: {organizationId: {_eq: $id}, productId: {_in: $productIds}}){
        id
        organizationId            
        productId
        quantity
        unitId
        reservedQuantity           
    }
}`